import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Table, Input } from 'reactstrap';
import { Button } from 'reactstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

import {
    FormGroup,
    Label,
} from 'Actions';

import AppConfig from 'Constants/AppConfig';
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { editHackmotionReport } from 'Actions';

class EditForm extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: 0,
    };

    UNSAFE_componentWillMount() {

    }

    constructor(props) {
        console.log(props, "this.props.hackmotionreportlist")
        super(props);
        this.nodeRef = React.createRef();
        const cdate = this.props.hackmotionreportlist[0].cdate;
        const parsedDate = moment(cdate, "Do MMMM YYYY").toDate();
        this.state = {
            seldate: parsedDate,
            student: this.props.data.student,
            studentName: this.props.hackmotionreportlist[0].student,
            id: this.props.hackmotionreportlist[0].tsrID || '',
            reportname: this.props.hackmotionreportlist[0].tsr_reportname || '',
            selectedFile: [],
            heightProportion: 1600,
            widthProportion: 500
        };
        this.onFileChange = this.onFileChange.bind(this);
    }

    selstudent = (evt) => {
        var stdid = evt.value;
        this.setState({ student: stdid });
    }

    selectdate = (date) => {
        this.setState({ seldate: date });
    }

    handleFormSubmit = () => {
        const data = {
            target: {
                student: this.state.student,
                seldate: this.state.seldate,
                reportname: this.state.reportname,
                fileupl: this.state.selectedFile,
                id: this.state.id,
            },
            oldfiles: this.props.hackmotionreportlist[0].tsr_filename,
            id: this.props.hackmotionreportlist[0].tsrID

        };
        this.props.editHackmotionReport(data);
        setTimeout(() => {
            this.props.onClick();
        }, 2000);
    };


    onFileChange(event) {
        const files = event.target.files;
        for (let i = 0; i < files.length; i++) {
            const element = files[i];

            this.convertBase64(element).then(result => this.setState({
                selectedFile: [...this.state.selectedFile, result]
            }));
        }
    }



    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    static propTypes = {
        classes: PropTypes.object,
        prev: PropTypes.number,
    };


    render() {
        const { hackmotionreportlist, loading } = this.props;
        const allfile = hackmotionreportlist[0] ? hackmotionreportlist[0].tsr_filename : null;

        if (allfile === '' || allfile === null) {
            var exfiles = [];
            var filecnt = 0;

        } else {
            var exfiles = allfile.split(',');
            var filecnt = exfiles.length;
        }


        const styles = {
            subheading: {
                fontWeight: "bold"
            }
        }


        return (
            <div>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <RctCollapsibleCard heading="Create Report Edit">
                                <div className="float-right">
                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning " onClick={this.props.onClick}>Back</button>
                                </div>
                                <div className="table-responsive">
                                    <Table hover bordered striped>
                                        <tbody>
                                            <tr>
                                                <td>STUDENT</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="student"
                                                        value={this.state.studentName}
                                                        disabled
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>DATE</td>
                                                <td>
                                                    <DatePicker
                                                        className="form-control"
                                                        id="seldate"
                                                        name="seldate"
                                                        autoComplete="off"
                                                        required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate} 
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>REPORT NAME</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="reportname"
                                                        value={this.state.reportname}
                                                        onChange={(e) => this.setState({ reportname: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>UPLOAD FILES</td>
                                                <td>
                                                    <input type="file" name="fileupl" id="fileupl" onChange={(e) => this.onFileChange(e)} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <input type="submit" onClick={this.handleFormSubmit} className="mr-3 mb-3 btn btn-outline-primary" />
                                    </div>
                                </div>
                            </RctCollapsibleCard>
                        </div>
                        <div className="col-sm-12 col-md-8" ref={this.nodeRef}>
                            <CarouselProvider
                                naturalSlideWidth={this.state.widthProportion}
                                naturalSlideHeight={this.state.heightProportion}
                                totalSlides={filecnt}
                            >
                                <div className="sdfsdf">
                                    <div className="text-center" style={{ marginTop: "-30px" }}>
                                        {exfiles.map((uptval, idx) => (
                                            <Dot className="text-center" slide={idx}>{idx + 1}</Dot>
                                        ))}
                                    </div>
                                </div>
                                <Slider>
                                    {exfiles.map((uptval, idx) => (
                                        <Slide index={idx}>
                                            <RctCollapsibleCard>
                                                <iframe src={AppConfig.apiurl + '/theme/img/hackmotion/' + uptval} width="100%" height={600}></iframe>
                                            </RctCollapsibleCard>
                                        </Slide>
                                    ))}
                                </Slider>
                            </CarouselProvider>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ hackmotionreport, mostlyused }) => {
    const { hackmotionreportlist, loading } = hackmotionreport;
    const { studentlists } = mostlyused;
    return { hackmotionreportlist, studentlists, loading };
}

export default connect(mapStateToProps, { editHackmotionReport })(EditForm);
